import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../../layouts/Blogsidebar';
import $ from 'jquery';
import 'magnific-popup';

import blogthumb from '../../../assets/img/blog/details/1.jpg';
import gallerythumb from '../../../assets/img/blog/details/2.jpg';
import comment1 from '../../../assets/img/people/1.jpg';
import comment2 from '../../../assets/img/people/2.jpg'; 
import galimg1 from '../../../assets/img/blog/details/3.jpg'; 
import galimg2 from '../../../assets/img/blog/details/4.jpg'; 

const gallerypost = [
    { img: galimg1 },
    { img: galimg2 },
];
// Tags
const tagspost = [
    { tag: 'Health' },
    { tag: 'Spa' },
    { tag: 'Fiber' },
];
// Share
const socialshare = [
    { icon: 'facebook-f', url: '/' },
    { icon: 'linkedin-in', url: '/' },
    { icon: 'twitter', url: '/' },
    { icon: 'youtube', url: '/' },
];

class Content extends Component {
    componentDidMount() {
        function popup() {
            $('.gallery-thumb').magnificPopup({
                type: 'image',
                gallery: {
                    enabled: true
                },
            });
        }
        popup();
    }
    render() {
        return (
            <div className="section sigma_post-single">
                <div className="container">
                    <div className="row">
                        {/* Sidebar Start */}
                        <div className="col-lg-4">
                            <Sidebar />
                        </div>
                        {/* Sidebar End */}
                        <div className="col-lg-8">
                            <div className="entry-content">
                                <div className="sigma_post-single-thumb">
                                    <img src={blogthumb} alt="" />
                                </div>
                                <h3 className="entry-title">We provide daily routines</h3>
                                <div className="sigma_post-meta">
                                    <div className="sigma_post-categories">
                                        <Link to="/blog-details" className="sigma_post-category">T-shirt Design</Link>
                                    </div>
                                    <Link to="/blog-details" className="sigma_post-date"> <i className="far fa-calendar" /> May 20, 2021</Link>
                                </div>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type
                                    specimen book.
                                    It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more
                                    recently with
                                    desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum
          </p>
                                <h4>Becoming a better version of you</h4>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. <Link to="/">Lorem Ipsum has been the industry's</Link> standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it
            to make a type specimen book.
          </p>
                                <Link to={gallerythumb} className="gallery-thumb">
                                    <img src={gallerythumb} alt="post" />
                                </Link>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
                                    galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting
          </p>
                                <div className="row">
                                    {gallerypost.map((item, i) => (
                                        <div className="col-md-6" key={i}>
                                            <Link to={item.img} className="gallery-thumb">
                                                <img src={item.img} alt="" />
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
                                    galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release
                                    of Letraset sheets
                                    containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
          </p>
                                <blockquote>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
                                </blockquote>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type
                                    specimen book.
                                    It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more
                                    recently with
                                    desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum
          </p>
                            </div>
                            {/* Post Meta Start */}
                            <div className="sigma_post-single-meta">
                                <div className="sigma_post-single-meta-item">
                                    <h6>Tags</h6>
                                    <div className="tagcloud">
                                        {tagspost.map((item, i) => (
                                            <Link to="/blog-details" key={i}>#{item.tag}</Link>
                                        ))}
                                    </div>
                                </div>
                                <div className="sigma_post-single-meta-item sigma_post-share">
                                    <h6>Share</h6>
                                    <ul className="sigma_sm">
                                        {socialshare.map((item, i) => (
                                            <li key={i}>
                                                <Link to={item.url}>
                                                    <i className={"fab fa-" + item.icon + ""} />
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            {/* Post Meta End */}
                            {/* Comments Start */}
                            <div className="section pb-0">
                                <h6>Comments</h6>
                                <div className="comments-list">
                                    <ul>
                                        <li className="comment-item">
                                            <img src={comment1} alt="" />
                                            <div className="comment-body">
                                                <h5>Robert John</h5>
                                                <p>Leverage agile frameworks to provide a robust synopsis for high level overviews. Iterative approaches to corporate strategy foster collaborative thinking to further the overall value proposition.</p>
                                                <Link to="/" className="btn-link"> Reply <i className="far fa-reply" /> </Link>
                                                <span> <i className="far fa-clock" /> January 13 2020</span>
                                            </div>
                                        </li>
                                        <li className="comment-item">
                                            <img src={comment2} alt="" />
                                            <div className="comment-body">
                                                <h5>Christine Hill</h5>
                                                <p>Leverage agile frameworks to provide a robust synopsis for high level overviews. Iterative approaches</p>
                                                <Link to="/" className="btn-link"> Reply <i className="far fa-reply" /> </Link>
                                                <span> <i className="far fa-clock" /> December 27 2020</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="section pb-0">
                                <h6>Leave a Comment</h6>
                                <div className="comment-form">
                                    <form method="post">
                                        <div className="row">
                                            <div className="col-md-6 form-group">
                                                <input type="text" className="form-control" placeholder="Full Name" name="fname" />
                                            </div>
                                            <div className="col-md-6 form-group">
                                                <input type="email" className="form-control" placeholder="Email Address" name="email" />
                                            </div>
                                            <div className="col-md-12 form-group">
                                                <textarea className="form-control" placeholder="Type your comment..." name="comment" rows={7} />
                                            </div>
                                        </div>
                                        <button type="submit" className="sigma_btn-custom secondary btn-pill" name="button">Post Comment</button>
                                    </form>
                                </div>
                            </div>
                            {/* Comments End */}
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default Content;